/* eslint-disable simple-import-sort/imports, import/no-extraneous-dependencies */
// This scope eslint is disabled to prevent auto sort of import statements as they are important here.
import 'react-app-polyfill/stable';
import 'core-js/proposals/string-replace-all';

import { render } from 'react-dom';

import { MainApp } from '@edf-pkg/app-main';

import { getEnvironmentName, getStagingEnvironmentDeploymentTag, isDev, isOnPremiseInstance, isProd } from '$app-web/utils';

import WebAppContainer from './containers/web-app-container';
import { StoredUrlProvider } from './context/stored-url.context';
import { ReactQueryProvider } from './api';

const ROOT_ELEMENT = document.getElementById('root')!;

function renderWebApp() {
    if (isProd() || isOnPremiseInstance()) {
        // eslint-disable-next-line no-console
        console.log(
            `ENV: ${getEnvironmentName()}`,
            `staging_envrionment_deployment_tag: ${getStagingEnvironmentDeploymentTag()}`
        );
    }

    render(
        <MainApp>
            <StoredUrlProvider>
                <ReactQueryProvider>
                    <WebAppContainer />
                </ReactQueryProvider>
            </StoredUrlProvider>
        </MainApp>,
        ROOT_ELEMENT
    );
}

renderWebApp();

if (isDev()) {
    if (module.hot != null) {
        module.hot.accept('./containers/web-app-container', () => {
            renderWebApp();
        });
    }
}
